<template>
  <div v-show="showModal" class="paypal-confirm-component">
    <div class="model-container">
      <div
        class="price-detail-list-container"
        :class="{ paypal: payType === 'paypal' }"
      >
        <div class="paypal-icon-container" v-if="payType === 'paypal'">
          <div class="paypal-icon"></div>
        </div>
        <div class="item">
          <div class="title">
            {{ $t("planSubscriptionPage.planDetailNameTitle") }}
          </div>
          <div class="detail">{{ model.planName }}</div>
        </div>
        <div class="item">
          <div class="title">
            {{ $t("planSubscriptionPage.planDetailPreMonthTitle") }}
          </div>
          <div class="detail">
            <label
              v-if="model.interval !== 1"
              style="text-decoration: line-through"
              >{{ model.yearOldPrice }}</label
            >
            {{ model.pricePerMonth }}
          </div>
        </div>
        <div class="item">
          <div class="title">
            {{ $t("myPlanPage.accountInfo.planNextTypeMonth") }}
          </div>
          <div class="detail">
            {{ model.interval }}
            <template v-if="model.interval === 1"
              >{{ $t("myPlanPage.accountInfo.planNextTypeMonth") }}
            </template>
            <template v-if="model.interval > 1"
              >{{ $t("myPlanPage.accountInfo.planNextTypeMonths") }}
            </template>
          </div>
        </div>
        <div class="item" v-if="model.hasDiscount">
          <div class="title">{{ model.discountText }}</div>
          <div class="detail">-${{ model.discountPrice }}</div>
        </div>
        <div class="splice-line"></div>
        <div class="item total">
          <div class="title">
            {{ $t("planSubscriptionPage.planDetailTotalPriceTitle") }}
          </div>
          <div class="detail">{{ model.totalPrice }}</div>
        </div>
      </div>
      <div class="price-tips" v-show="notSupportCurrency">
        {{ $t("planSubscriptionPage.priceTip") }}
      </div>
      <hi-button
        type="primary"
        v-show="!notSupportCurrency"
        :class="{ paypal: payType === 'paypal' }"
        @click="subscribeClick"
        class="subscribe-btn stripe"
        >{{ $t("planSubscriptionPage.stripBtn") }}
      </hi-button>
      <div
        v-show="notSupportCurrency"
        @click="subscribeClick"
        class="subscribe-btn not-support paypal"
      >
        <div class="first-text">Subscribe - {{ model.totalPrice }}</div>
        <div>(Paypal Payment is in US Dollar)</div>
      </div>
      <hi-button type="text" class="cancel-btn" @click="cancel">{{
        $t("common.cancel")
      }}</hi-button>
    </div>
  </div>
</template>

<script>
import hiButton from "../../../components/button/Index";
export default {
  name: "PayPalConfirmComponent",
  components: { hiButton },
  model: {
    prop: "show",
    event: "updateShow",
  },
  props: {
    // 是否显示已做v-model
    show: {
      type: Boolean,
      default: false,
    },
    model: {
      type: Object,
      required: true,
    },
    payType: {
      type: String,
      default: "paypal",
    },
  },
  computed: {
    notSupportCurrency() {
      // 如果遇到不支持的币种则显示特殊样式
      if (this.payType === "paypal" && !this.model.payPalSupportCurrency) {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      showModal: this.show,
    };
  },
  methods: {
    /**
     * 订阅回调
     */
    subscribeClick() {
      this.$emit("subscribe", this.payType);
    },
    /**
     * 点击取消按钮隐藏弹出
     */
    cancel() {
      this.showModal = false;
    },
  },
  watch: {
    showModal(val) {
      this.$emit("updateShow", val);
    },
    show(val) {
      this.showModal = val;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import "../../../assets/style/theme.less";
.paypal-confirm-component {
  position: fixed;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  left: 0;
  top: 0;
  z-index: 401;
  .model-container {
    width: 640px;
    max-width: 90vw;
    background: white;
    padding: 30px 15px 0 15px;
    border-radius: 10px;
    // ios设备整体向上移动
    &.ios-platform {
      position: relative;
      bottom: 50px;
    }
    .price-detail-list-container {
      font-size: 14px;
      border: 1px solid @border-color;
      padding: 13px 15px;
      border-radius: 5px;
      position: relative;
      .paypal-icon-container {
        padding: 0 7px;
        background: white;
        position: absolute;
        left: 13px;
        top: -13px;
        .paypal-icon {
          width: 80px;
          height: 24px;
          background-image: url("../../../../public/images/payment/paypal_logo@3x.png");
          background-size: contain;
        }
      }
      .item {
        display: flex;
        justify-content: space-between;
        height: 22px;
        line-height: 22px;
        margin-top: 5px;
        align-items: center;
        &:first-child {
          margin-top: 0;
        }
        &.total {
          font-weight: 600;
          margin-top: 0;
          .title {
            color: @theme-color;
            font-size: 16px;
          }
          .detail {
            font-size: 16px;
          }
        }
        .title {
          text-transform: capitalize;
        }
        .detail {
          color: @theme-color;
        }
      }
      .splice-line {
        height: 1px;
        background: @border-color;
        margin: 10px 0;
      }
    }
    .price-tips {
      text-align: right;
      font-size: 12px;
      color: @font-color-gray;
      margin-top: 5px;
    }
    .subscribe-btn {
      width: 100%;
      height: 44px;
      margin-top: 20px;
      background: @theme-color;
      cursor: pointer;
      &:hover {
        opacity: 0.7;
      }
      &.stripe {
        background: @theme-color;
      }
      &.not-support {
        text-align: center;
        height: auto;
        padding: 12px 0;
        border-radius: 4px;
        &.paypal {
          color: white !important;
          background: #006fb9;
        }
        .first-text {
          font-size: 20px;
          font-weight: 500;
          margin-bottom: 4px;
        }
      }
    }
    .cancel-btn {
      width: 100%;
      color: @theme-color;
      padding: 0;
      margin: 18px 0;
      &:active {
        opacity: 0.7;
      }
    }
  }
}
</style>
